import { Component, OnInit } from '@angular/core';
import { CadastroUsuarioService } from '../cadastro-usuario.service';
import { UtilsService } from '../utils.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css']
})
export class CadastroComponent implements OnInit {
  progressBar:boolean = false;
  id:number;
  email:string = '';
  nome:string = '';
  senha: string = '';
  confirmSenha:string = '';
  foneContato: string = '';

  constructor(private cadastroUsuario:CadastroUsuarioService,
              public router: Router,
              private auth:AuthService) {
    
  }

  ngOnInit() {
    //console.log(localStorage.getItem("cadastro"));
    this.nome = "";
    this.senha = "";
    this.foneContato = "";
    this.email = (localStorage.getItem("cadastro") !== 'undefined' && localStorage.getItem("cadastro") !== 'null' ? localStorage.getItem("cadastro") : '');
  }

  cadastrar() {
    if (this.nome == "") {
      UtilsService.alerta("Favor preencher o nome completo!", "erro");
      return;
    } else if (this.foneContato == "") {
      UtilsService.alerta("Favor preencher o número do celular!", "erro");
      return;
    } else if (this.email == "") {
      UtilsService.alerta("Favor preencher o e-mail!", "erro");
      return;
    } else  if (this.confirmSenha !== this.senha) {
      UtilsService.alerta("As senhas não conferem, favor verificar!", "erro");
      return;
    } 

    this.progressBar = true;

    let form = {
      "tokenConfirmacao": (localStorage.getItem('tokenConfirmacao') !== 'null' ? localStorage.getItem('tokenConfirmacao') : ''),
      "email": this.email,
      "nome": this.nome,
      "senha": this.senha,
      "foneContato": this.foneContato
    }
    this.cadastroUsuario.cadastrarUsuario(form).subscribe((resp) => {
      try {
          //console.log(resp);
          localStorage.setItem('tokenConfirmacao', '');
          if (resp["id"] !== null) 
            UtilsService.alerta("Usuário cadastrado com sucesso.");
          else 
            UtilsService.alerta("Usuário atualizado com sucesso.");
          
          this.progressBar = false;
          this.router.navigate(['/']);
        } catch (error) {
          
        }
    }, resp => {
      this.progressBar = false;
      UtilsService.alerta(resp.error.message, 'erro');
    })
  }

}